<div class="footer-box">
  <div class="container-box">
    <div class="container-box">

      <div class="icon-box">
        <div class="icon-image icon--logo-footer"></div>
      </div>

      <div class="year-box">{{'©'}} {{currentYear}} {{'Sobrado AG'}}</div>

      <div class="additional-box">
        <div class="phone-address">{{'+41 44 515 49 49, Limmatquai 122, 8001 Zürich'}}</div>
        <div class="email">
          <a [href]="supportMailto">{{ feedbackEmail }}</a>
        </div>
        <div class="data-protection">
          <a [href]="getRedirectLink(LINKS.LINK_DATA_PROTECTION)">{{'front.sng.footer.data.protection' | translate}}</a>
        </div>
      </div>

      <div class="app-info-box">
        <div class="version">{{'front.sng.footer.version' | translate}}: {{'fe9a7fcb'}}</div>
        <div class="speed">{{'front.sng.footer.speed' | translate}}: {{'0.86s'}}</div>
        <div class="memory">{{'front.sng.footer.memory' | translate}}: {{'24.00MB'}}</div>
      </div>

    </div>
  </div>
</div>

